import { Component } from '@angular/core';

import {
  AlertController,
  ModalController,
  NavController,
  NavParams
} from 'ionic-angular';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/take';

import { HexonProvider } from '../../providers/hexon/hexon';
import { NewLinkPage } from '../new-link/new-link';
import { CommentsPage } from '../comments/comments';
import { SiteSettingsPage } from '../site-settings/site-settings';
import { IAccount } from '../../models/account';
import { RefreshProvider } from '../../providers/refresh/refresh';
import { BlockedVehiclesPage } from '../blocked-vehicles/blocked-vehicles';

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {
  public accounts$: Observable<IAccount[]>;
  public companyName$: Observable<string>;
  private reload$: Subject<void>;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private hexon: HexonProvider,
    private alertCtrl: AlertController,
    private refresh: RefreshProvider
  ) {
    this.reload$ = new Subject<void>();

    // On every event in reload$, the accounts are fetched again
    this.accounts$ = this.reload$.switchMap(() => {
      return this.hexon.getAccounts$();
    });
    this.companyName$ = navParams.get('companyName$');
  }

  public ionViewDidEnter() {
    this.reload();
  }

  public goToOverview() {
    this.refresh.refresh();
    this.navCtrl.pop();
  }

  public async setSettings(site: IAccount) {
    try {
      const settings = await this.hexon
        .getSiteSettings$(site.site_code)
        .first()
        .toPromise();

      const modal = this.modalCtrl.create(SiteSettingsPage, {
        settings,
        sitename: site.name,
        sitecode: site.site_code
      });
      modal.present();
    } catch (e) {}
  }

  public deactivate(site: IAccount) {
    const alert = this.alertCtrl.create({
      title: 'Deactiveren',
      subTitle: site.name,
      message: `Wilt u de koppeling met ${site.name} uitschakelen?`,
      buttons: [
        {
          text: 'Annuleer',
          role: 'cancel'
        },
        {
          text: 'Deactiveer',
          handler: data => {
            (async () => {
              await this.hexon
                // tslint:disable-next-line: quotemark
                .deactivate$(site.site_code, data === 'removeAll')
                .first()
                .toPromise()
                .then(result => {
                  this.processDeactivate(result, site.site_code);
                });
            })();
          }
        }
      ]
    });
    alert.present();
  }

  public reload() {
    this.reload$.next();
  }

  public newLink() {
    const modal = this.modalCtrl.create(NewLinkPage, {
      reload: this.reload.bind(this)
    });
    modal.present();
  }

  public editComment() {
    const modal = this.modalCtrl.create(CommentsPage);
    modal.present();
  }

  public processDeactivate(data, siteCode){
    // check if errors is there if not there are still vehciles that are published
    // those have to be depublished befor the site can be deactivated
    if (data.errors === undefined){
      this.modalCtrl.create(BlockedVehiclesPage, [data, siteCode]).present();
    }else{
      this.refresh.setDirty();
      this.reload();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts